import { TOKEN_LOCAL_STORAGE, USER_ID_LOCAL_STORAGE } from "../constants/app.constant";

export const getFbAccessToken = () => {
  return localStorage.getItem(TOKEN_LOCAL_STORAGE);
};

export const getUserId = () => {
  return localStorage.getItem(USER_ID_LOCAL_STORAGE);
};
